import(/* webpackMode: "eager" */ "/var/www/msa-driver-frontend/src/app/error.tsx");
